export default __webpack_public_path__ + "static/media/hz396.f90a33e3.svg";